<template>
  <i-form
    v-scroll-to-invalid
    class="form"
    name="tapes-form"
    @submit="handleSubmit"
  >
    <div class="dimensions">
      <strapi-label :label="labels[TapesLabels.dimensions]" />

      <div class="form-field-group">
        <!--width field-->
        <zaproo-select
          v-if="fields[TapesFields.width]"
          v-model="form.width"
          :removable="false"
          :rules="fieldRules[TapesFields.width]"
          :placeholder="$t('Select option')"
          searchable
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
          name="width"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[TapesFields.width]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[TapesFields.width].options"
            :key="option.value"
            :value="option.value"
            >{{ option.title }}</zaproo-select-option
          >
        </zaproo-select>
      </div>
    </div>

    <div class="material mt-6">
      <strapi-label :label="labels[TapesLabels.material]" />
      <div class="form-field-group">
        <!--material field-->
        <zaproo-select
          v-if="fields[TapesFields.material]"
          v-model="form.material"
          :removable="false"
          :rules="fieldRules[TapesFields.material]"
          :placeholder="$t('Select option')"
          :description="
            isPaper && isFifteenAmount
              ? $t('Paper tape can be ordered from a quantity of 15 boxes')
              : ''
          "
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
          name="material"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[TapesFields.material]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[TapesFields.material].options"
            :key="option.value"
            :value="option.value"
            >{{ option.title }}</zaproo-select-option
          >
        </zaproo-select>

        <!--mainColor field-->
        <zaproo-select
          v-if="fields[TapesFields.mainColor]"
          v-model="form.mainColor"
          :removable="false"
          :rules="fieldRules[TapesFields.mainColor]"
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
          name="main_color"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[TapesFields.mainColor]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[TapesFields.mainColor].options"
            :key="option.value"
            :value="option.value"
            :disabled="isPaper && option.value === 'transparent'"
            >{{ option.title }}</zaproo-select-option
          >
        </zaproo-select>
      </div>
    </div>

    <div class="print mt-6">
      <strapi-label :label="labels[TapesLabels.print]" />
      <div class="form-field-group">
        <div>
          <!--numberOfPrintColors field-->
          <zaproo-select
            v-if="fields[TapesFields.numberOfPrintColors]"
            v-model="form.numberOfPrintColors"
            :removable="false"
            :rules="fieldRules[TapesFields.numberOfPrintColors]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
            name="print_colors"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[TapesFields.numberOfPrintColors]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[TapesFields.numberOfPrintColors].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--designFile field-->
          <zaproo-file-input
            v-if="fields[TapesFields.designFile]"
            v-model="form.designFile"
            class="mt-3"
            name="designFile"
            :rules="fieldRules[TapesFields.designFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="fields[TapesFields.designFile].placeholder"
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[TapesFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>
    </div>

    <special-order-form-general-contacts-part
      v-model="form"
      :loading="loading"
      class="general-contacts-form"
    >
      <div class="form-field-group">
        <!--amountBoxes field-->
        <zaproo-select
          v-if="fields[TapesFields.amountBoxes]"
          v-model="form.amountBoxes"
          :removable="false"
          :description="
            totalAmount ? t('Total: {n} rolls', { n: totalAmount }) : ''
          "
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          field-classes="bg-white"
          class="form-field checkmark"
          name="amount"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[TapesFields.amountBoxes]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[TapesFields.amountBoxes].options"
            :key="option.value"
            :value="option.value"
            :disabled="isPaper && isFifteenAmount && option.value !== '15'"
            >{{ option.title }}</zaproo-select-option
          >
        </zaproo-select>

        <zaproo-input
          v-if="isAmountBoxesOther"
          v-model="form.otherAmountBoxes"
          type="number"
          name="other_amount"
          :rules="fieldRules[TapesFields.otherAmountBoxes]"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[TapesFields.otherAmountBoxes]"
            />
          </template>
        </zaproo-input>
      </div>
    </special-order-form-general-contacts-part>
  </i-form>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import { TapesFields, TapesLabels } from "./types";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import type {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";

import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import { getFieldDefaultModel } from "~/modules/special-orders/helpers";

import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

// For prevent type error https://github.com/jojomatik/nuxt-3-base/issues/5
const { t } = useI18n();

const labels = computed(() => labelCollection(TapesLabels));
const fields = computed(() => fieldsCollection(TapesFields));
const fieldRules = useSpecialOrderFieldRules<typeof TapesFields>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isAmountBoxesOther = computed<boolean>(
  () => form.value.amountBoxes === "other",
);
const isPaper = computed<boolean>(() => form.value.material === "paper");
const isFifteenAmount = computed<boolean>(
  () => form.value.amountBoxes === "15",
);

const currentWidth = computed<number>(() =>
  isNaN(+form.value.width) ? 1 : +form.value.width,
);
const currentQtyRolls = computed<number | undefined>(() => {
  const rollsInBox =
    fields.value[TapesFields.width]?.additional?.rollsInBox[currentWidth.value];

  return typeof rollsInBox === "number" ? rollsInBox : undefined;
});
const totalAmount = computed<number>(() => {
  const currentAmountBoxes = isNaN(+form.value.amountBoxes)
    ? +(form.value.otherAmountBoxes || "") || 1
    : +form.value.amountBoxes;

  return currentQtyRolls.value ? currentQtyRolls.value * currentAmountBoxes : 0;
});

function resetForm() {
  return {
    width: getFieldDefaultModel(fields.value[TapesFields.width]) || "",
    material: getFieldDefaultModel(fields.value[TapesFields.material]),
    mainColor: getFieldDefaultModel(fields.value[TapesFields.mainColor]),
    numberOfPrintColors: getFieldDefaultModel(
      fields.value[TapesFields.numberOfPrintColors],
    ),
    amountBoxes:
      getFieldDefaultModel(fields.value[TapesFields.amountBoxes]) || "",
    otherAmountBoxes: getFieldDefaultModel(
      fields.value[TapesFields.otherAmountBoxes],
    ),
    designFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

watch(isPaper, (newValue) => {
  if (newValue) {
    const currentValue = (
      fields.value[TapesFields.amountBoxes]?.options || []
    ).find((i) => i.value === "15");

    if (currentValue) {
      form.value.amountBoxes = currentValue.value;
    }
  }
});

useFormFieldCleaner(
  {
    otherAmountBoxes: {
      default: () =>
        getFieldDefaultModel(fields.value[TapesFields.otherAmountBoxes]),
      ref: isAmountBoxesOther,
    },
  },
  form,
);
</script>
